import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classPrivateFieldInitSpec from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldSet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _classPrivateFieldGet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/rpc-provider authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert, isNumber, isString, isUndefined, stringify } from '@polkadot/util';
import RpcError from "./error.js";

function formatErrorData(data) {
  if (isUndefined(data)) {
    return '';
  }

  var formatted = ": ".concat(isString(data) ? data.replace(/Error\("/g, '').replace(/\("/g, '(').replace(/"\)/g, ')').replace(/\(/g, ', ').replace(/\)/g, '') : stringify(data)); // We need some sort of cut-off here since these can be very large and
  // very nested, pick a number and trim the result display to it

  return formatted.length <= 256 ? formatted : "".concat(formatted.substring(0, 255), "\u2026");
}

function checkError(error) {
  if (error) {
    var code = error.code,
        data = error.data,
        message = error.message;
    throw new RpcError("".concat(code, ": ").concat(message).concat(formatErrorData(data)), code, data);
  }
}
/** @internal */


var _id = /*#__PURE__*/new WeakMap();

export var RpcCoder = /*#__PURE__*/function () {
  function RpcCoder() {
    _classCallCheck(this, RpcCoder);

    _classPrivateFieldInitSpec(this, _id, {
      writable: true,
      value: 0
    });
  }

  _createClass(RpcCoder, [{
    key: "decodeResponse",
    value: function decodeResponse(response) {
      assert(response && response.jsonrpc === '2.0', 'Invalid jsonrpc field in decoded object');
      var isSubscription = !isUndefined(response.params) && !isUndefined(response.method);
      assert(isNumber(response.id) || isSubscription && (isNumber(response.params.subscription) || isString(response.params.subscription)), 'Invalid id field in decoded object');
      checkError(response.error);
      assert(!isUndefined(response.result) || isSubscription, 'No result found in jsonrpc response');

      if (isSubscription) {
        checkError(response.params.error);
        return response.params.result;
      }

      return response.result;
    }
  }, {
    key: "encodeJson",
    value: function encodeJson(method, params) {
      var _this$encodeObject = this.encodeObject(method, params),
          _this$encodeObject2 = _slicedToArray(_this$encodeObject, 2),
          id = _this$encodeObject2[0],
          data = _this$encodeObject2[1];

      return [id, stringify(data)];
    }
  }, {
    key: "encodeObject",
    value: function encodeObject(method, params) {
      var id = _classPrivateFieldSet(this, _id, +_classPrivateFieldGet(this, _id) + 1);

      return [id, {
        id: id,
        jsonrpc: '2.0',
        method: method,
        params: params
      }];
    }
  }]);

  return RpcCoder;
}();